import { render, staticRenderFns } from "./WordleInput.vue?vue&type=template&id=72f73be1&scoped=true"
import script from "./WordleInput.vue?vue&type=script&lang=js"
export * from "./WordleInput.vue?vue&type=script&lang=js"
import style0 from "./WordleInput.vue?vue&type=style&index=0&id=72f73be1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f73be1",
  null
  
)

export default component.exports